import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Lottie from 'react-lottie';

import branchSpinnerJson from 'core/assets/lottie/branch-spinner.min.json';
import { Label } from 'core/components/label';

const useStyles = makeStyles({
  animation: {
    width: 128,
    height: 128,
    margin: '0 auto',
    paddingBottom: 25
  },
  container: {
    margin: '0 auto',
    paddingTop: 40
  }
});

function BranchSpinner({ className }) {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <div className={classNames(styles.animation, className)}>
        <Lottie options={{ animationData: branchSpinnerJson, loop: true, autoplay: true }} />
      </div>
      <Label type="darkSmall">Processing the purchase...</Label>
    </div>
  );
}

BranchSpinner.propTypes = {
  className: PropTypes.string
};

BranchSpinner.defaultProps = {
  className: ''
};

export default BranchSpinner;
